
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blindados",
      function () {
        return require("private-next-pages/blindados/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blindados"])
      });
    }
  